// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { infoProps } from "@store/Themes/common/props/info";
import { useContext } from "react";
import * as React from "react";

export interface EditedRowInfoBoxStyles {
    infoBoxStyle?: InfosBoxProps;
    wrapper?: InjectableCss;
}

export const deliveryTermsStyles: EditedRowInfoBoxStyles = {
    infoBoxStyle: {
        type: "warning",
    },
};
const styles = deliveryTermsStyles;

const EditedRowInfoBox = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.properties.deliveryTerms) {
        return null;
    }

    return (
        <InfosBox {...styles.infoBoxStyle}>
            <Typography>{translate("Please Note that there were some changes in your order.")}</Typography>
            <ul>
                <li>test !</li>
            </ul>
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: EditedRowInfoBox,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
